import { Component } from '@angular/core';
import { HostListener } from '@angular/core';
import { SessionService } from './Services/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
 

  UAT_IP_1 = 'https://dsu.uat.fmcone.in/#/'
  //UAT_IP_2 = 'http://169.38.100.202:9246/#/'
  //PROD_IP_1 = 'http://169.38.100.229:8220/#/'
  localHost = 'http://localhost:4200'
  title = 'Demo Samples';
  constructor(private session: SessionService) { }

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:wheel', ['$event'])
  @HostListener('mousemove', ['$event'])
  @HostListener('window:scroll', ['$event'])
  onclick() {
    if ((window.location.href !== this.UAT_IP_1 + "DSU/Login")
    //&& (window.location.href !== this.UAT_IP_2 + "DSU/Login")  
    //&& (window.location.href !== this.PROD_IP_1 + "MCMaterial/Login")
    && (window.location.href !== this.localHost + "DSU/Login")
    ) {
      this.session.resetSession();
    }
  }
}
